<template>
  <div v-if="visible" class="row">
    <div class="col">
      <div class="text-left">
        <strong class="d-block">Nombre de la escuela:</strong>
        <span>{{ schoolName }}</span>
      </div>
    </div>
    <div class="col">
      <div class="text-left">
        <strong class="d-block">Dirección:</strong>
        <span>{{ address }}</span>
      </div>
    </div>
    <div class="col">
      <div class="text-left">
        <strong class="d-block">Pueblo:</strong>
        <span>{{ town }}</span>
      </div>
    </div>
    <div class="col">
      <div class="text-left">
        <strong class="d-block">Codigo Postal:</strong>
        <span>{{ zipCode }}</span>
      </div>
    </div>
    <div class="col">
      <div class="text-left">
        <strong class="d-block">Teléfono:</strong>
        <span>{{ phone }}</span>
      </div>
    </div>
    <div class="col">
      <div class="text-left">
        <div>
          <button
            v-if="isPeiDraft"
            class="btn btn-dropdown-actions dropdown-toggle pt-1"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Acciones
          </button>
          <div class="dropdown-menu pb-0 custom-dropdown">
            <a class="drop-item" href="#" @click.prevent="onClickShowLocation()">
              <i class="fas fa-edit text-green pr-1" />
              <span>Editar</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router/index';
export default {
  name: 'StudentLocation',
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    schoolName: {
      type: String,
      default: () => '',
    },
    phone: {
      type: String,
      default: () => '',
    },
    town: {
      type: String,
      default: () => '',
    },
    zipCode: {
      type: String,
      default: () => '',
    },
    address: {
      type: String,
      default: () => '',
    },
    isPeiDraft: {
      type: Boolean,
      defaul: () => false,
    },
  },
  methods: {
    onClickShowLocation() {
      router.push({ path: '/pei/detail/unilaterallocations' });
    },
  },
};
</script>
<style scoped>
.custom-dropdown {
  float: left !important;
  width: 10px !important;
}

.custom-dropdown a {
  width: 100% !important;
  float: left !important;
}

.custom-dropdown span {
  background: none !important;
  color: #000 !important;
  padding: 5px 15px 5px 10px !important;
  float: left;
}

.custom-dropdown i {
  float: left !important;
  margin-top: 10px !important;
  margin-left: 10px;
}
</style>
